// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { ValidatorResult } from "../ui/types/Types";
import { SettingsWriteRequestDTO } from "../api/backend-openapi";

export const validate = (
  settingsUpdate: SettingsWriteRequestDTO
): ValidatorResult => {
  const result: ValidatorResult = {
    validate: true,
    message: ""
  };
  Object.entries(settingsUpdate).forEach(entry => {
    if (entry[1] <= 0) {
      result.validate = false;
      result.message = "global.error.negative";
    }
  });
  return result;
};
